




























































































































import Vue, { PropType } from "vue";
import eventBus from "@/services/eventBus";
import BankStatementApi from "../services/BankStatementApi";
import BankDocCarExcelParseResult from "../models/BankDocCarExcel";
import { BankStatementItemEntity } from "../models/BankDocument";
import { t } from "@/plugins/i18n";

interface Data {
  file: File | null;
  result: BankDocCarExcelParseResult | null;
  inProgress: boolean;
}

/**
 * SAKT169 – gépjármű részletező excel betöltése a bankkivonat tétel rögzítő felületről.
 * Az űrlapon megadott tétel (partner, terhelés/jóváírás, típus, altípus, pénznem) a sablon;
 * a párosított excel sorokból gépjárművenként egy-egy kivonat tétel készül, mindegyik a saját
 * utókalkulációs fejére kötve (1:1 kapcsolat, mint a "Gépjármű választás"-nál).
 */
export default Vue.extend({
  props: {
    statementId: { type: Number, required: true },
    item: { type: Object as PropType<BankStatementItemEntity>, required: true },
  },

  data: (): Data => ({
    file: null,
    result: null,
    inProgress: false,
  }),

  watch: {
    file() {
      // új fájl választásakor az előző előnézet már nem érvényes
      this.result = null;
    },
    "item.accountType"() {
      this.result = null;
    },
    "item.accountSubtype"() {
      this.result = null;
    },
  },

  computed: {
    canGenerate(): boolean {
      return !!this.result && this.result.matched.length > 0 && !this.inProgress;
    },
  },

  methods: {
    async parse() {
      if (!this.file || this.inProgress) {
        return;
      }

      this.inProgress = true;
      this.result = null;
      try {
        this.result = await BankStatementApi.parseBankDocCarExcel(
          this.statementId,
          this.file,
          this.item.accountType,
          this.item.accountSubtype
        );
      } catch (error) {
        // a hibát a http service már kiírta
        console.log(error);
      } finally {
        this.inProgress = false;
      }
    },

    async generate() {
      if (!this.canGenerate || !this.result) {
        return;
      }

      this.inProgress = true;
      try {
        const ids = await BankStatementApi.generateBankDocByCarExcel(this.statementId, this.item, this.result.matched);
        eventBus.$emit("success", t("BankStatement_KivonatTetelLetrehozvaAGepjarmuReszletezobol", [ids.length]));
        this.$emit("generated", ids);
        this.file = null;
        this.result = null;
      } catch (error) {
        console.log(error);
      } finally {
        this.inProgress = false;
      }
    },

    formatMoney(value: number): string {
      return `${(value ?? 0).toLocaleString("hu-HU", { maximumFractionDigits: 2 })} ${this.item.invCurrency || this.item.currency || ""}`.trim();
    },
  },
});
